import { FC, ReactNode, useEffect, useMemo } from "react";

import {
  IConfig,
  FlagProvider,
  useUnleashClient,
} from "@unleash/proxy-client-react";
import {
  UNLEASH_CLIENT_KEY,
  UNLEASH_FRONT_END,
  ENVIRONMENT,
} from "../../constants";
import { usePermissionsState, useUser } from "context";

const UNLEASH_FALLBACK_URL = "https://us.app.unleash-hosted.com";
const UNLEASH_FALLBACK_CLIENT_KEY = "Teams:development";

export const DEFAULT_UNLEASH_CLIENT_CONFIG: IConfig = {
  url: UNLEASH_FRONT_END || UNLEASH_FALLBACK_URL,
  clientKey: UNLEASH_CLIENT_KEY || UNLEASH_FALLBACK_CLIENT_KEY,
  appName: "teams",
  refreshInterval: 60,
  environment: ENVIRONMENT,
  customHeaders: {
    // have to set this to empty string to avoid 304 redirect
    "If-None-Match": "",
  },
};

const FeatureFlagClientInitializer: FC = () => {
  const [{ currentTeam }] = useUser();
  const { user } = usePermissionsState();

  const properties: Record<string, string> = useMemo(() => {
    const data: Record<string, string> = {};
    if (currentTeam?.id) {
      data.teamId = String(currentTeam?.id);
    }
    return data;
  }, [currentTeam?.id]);

  const featureFlagClient = useUnleashClient();

  useEffect(() => {
    featureFlagClient.updateContext({
      userId: (user && String(user.id)) ?? undefined,
      properties,
    });
  }, [user?.id, properties]);

  return null;
};

const FeatureFlagProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <FlagProvider config={DEFAULT_UNLEASH_CLIENT_CONFIG}>
      <FeatureFlagClientInitializer />
      {children}
    </FlagProvider>
  );
};

export default FeatureFlagProvider;
